import 'font-awesome/css/font-awesome.min.css';
import React from 'react';
import { ApolloProvider } from 'react-apollo';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import createApolloClient from './apollo-client';
import { Loading } from './components/partials';
import registerServiceWorker from './registerServiceWorker';
import Routes from './routes';
import rootSaga from './state/sagas';
import configureStore, { history } from './state/store';
import './styles/style.css';

async function initApp() {
  const { store, persistor } = configureStore();
  const apolloClient = await createApolloClient(store);

  const rootComponent = (
    <Provider store={store}>
      <PersistGate loading={<Loading />} persistor={persistor}>
        <ApolloProvider client={apolloClient}>
          <ConnectedRouter history={history}>
            <Routes />
          </ConnectedRouter>
        </ApolloProvider>
      </PersistGate>
    </Provider>
  );

  const rootElement = document.getElementById('root');

  ReactDOM.render(rootComponent, rootElement);
}

initApp();
rootSaga.run();
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js